// extracted by mini-css-extract-plugin
export default {"actualCost":"TaskFinancialInfoList_actualCost__6KxRK","summaryRow":"TaskFinancialInfoList_summaryRow__IY4RD"};